import styled from 'styled-components';

export const NeededDocs = styled.ul`
  padding: 0;
  font-size: 14px;
  line-height: 24px;

  > li {
    margin-left: 20px;
  }
`;
